import {getCurrentLang, storeCurrentLang} from "../../data/AuthTokenStorage";
import {mapState} from "vuex";
import {
    CHECK_USER
} from "../../store/authManagement/action_type";
export default {
    name: "Header",

    data() {
        return {
            menuStates:{},
            openList: null,
            openSearch: false,
            searchText: '',
            drawer: false,
            selectedFlag: 0,
            menuKey:0,
            flag: [
                'IR',
                'EN',
                'AR'
                // require('../../assets/images/flags/ir.svg'),
                // require('../../assets/images/flags/en.svg'),
                // require('../../assets/images/flags/ar.svg'),
            ],
            limitPosition: 100,
            scrolled: false,
            lastPosition: 0,
            // flag:[
            //     require('../../assets/images/flags/iran.png'),
            //     require('../../assets/images/flags/united-kingdom.png'),
            //     require('../../assets/images/flags/saudi-arabia.png'),
            // ],
            headerItems: [
                {
                    name: 'home',
                    type: 'single',
                    route: '/',
                    subDomain: []
                },
                {
                    name: 'aboutUs',
                    type: 'sublayer',
                    expanded: false,
                    route: '',
                    subDomain: [
                        {
                            name: 'about_ardakan',
                            route: '/about-ardakan'
                        },
                        {
                            name: 'management',
                            route: '/management'
                        },
                        {
                            name: 'export',
                            route: '/export'
                        },
                    ]
                },
                {
                    name: 'products',
                    type: 'sublayer',
                    expanded: false,
                    route: '',
                    subDomain: [
                        {
                            name: 'float_glass',
                            route: '/sub/glasses'
                        },
                        {
                            name: 'building_glass',
                            route: '/sub/glasses'
                        },
                        {
                            name: 'bloc',
                            route: '/sub/light-blocks'
                        },
                        {
                            name: 'dry_mortar',
                            route: '/sub/light-blocks/construction/products'
                        },
                        {
                            name: 'brick',
                            route: '/sub/light-blocks/construction/product/ajor'
                        },
                        {
                            name: 'carbonate',
                            route: '/material/single/937'
                        },
                        {
                            name: 'casting_sand',
                            route: '/material/single/938'
                        },
                        {
                            name: 'material',
                            route: '/material/single/939'
                        },

                    ]
                },
                // {
                //     name:'پروژه ها',
                //     type:'single',
                //     route:'projects',
                //     subDomain:[]
                // },
                // {
                //     name:'رویداد و نمایشگاه‌ها',
                //     type:'single',
                //     route:'show-place',
                //     subDomain:[]
                // },
                // {
                //     name:'مدیریت',
                //     type:'single',
                //     route:'management',
                //     subDomain:[]
                // },

                // {
                //     name: 'مسئولیت های اجتماعی',
                //     route: '/social-responsibilities',
                //     type:'single',
                //
                //     subDomain:[]
                // },
                {
                    name: 'news',
                    type: 'sublayer',
                    expanded: false,
                    route: '',
                    subDomain: [
                        {
                            name: 'events',
                            route: '/show-place'
                        },
                        {
                            name: 'projects',
                            route: '/projects'
                        },
                        {
                            name: 'all_news',
                            route: '/all-news'
                        },
                    ]
                },
                {
                    name: 'technical_info',
                    type: 'sublayer',
                    expanded: false,
                    route: '',
                    subDomain: [
                        {
                            name: 'certificates',
                            route: '/certificates'
                        },
                        {
                            name: 'blogs',
                            route: '/news'
                        },
                        {
                            name: 'gallery',
                            route: '/gallery'
                        },
                        {
                            name: 'catalogue',
                            route: '/catalogue'
                        },
                        {
                            name: 'faq',
                            route: '/faq'
                        },
                    ]
                },
                {
                    name: 'invited_to_cooperate',
                    type: 'sublayer',
                    expanded: false,
                    route: '',
                    subDomain: [
                        {
                            name: 'employment_form',
                            route: '/employment-form'
                        },
                        {
                            name: 'suppliers_form',
                            route: '/suppliers-form'
                        },
                        {
                            name: 'auctions_and_tenders',
                            route: '/auctions-and-tenders'
                        }
                    ]
                },
                {
                    name: 'contact_us',
                    type: 'single',
                    route: '/contact-us',
                    subDomain: []
                },
                //   {
                //   name:'تماس با ما',
                //   type:'single',
                //   route:'contact-us',
                //   subDomain:[]
                // },

            ],
        }
    },
    methods: {
        isValidHttpUrl(string) {
            let url;
            
            try {
              url = new URL(string);
            } catch (_) {
              return false;  
            }
          
            return url.protocol === "http:" || url.protocol === "https:";
          },
        gotoLink(link){
            if(this.isValidHttpUrl(link)) location.href=link;
            this.$router.push(link)
        },
        gotoSingle(item){
            this.$router.push("/single/"+item.id)
            this.$store.dispatch(`productManagement/clearSearch`)
        },
        clearSearch(){
            this.searchText="";
            //
        },
        search(){
            if(this.searchText.length < 2) return;
            this.$store.dispatch(`productManagement/searchProducts`,{q:this.searchText})
            .then(res=>{
                console.log(res)
            });
        },
        logout(){
            this.$store.dispatch(`authManagement/logout`);
            
          },
        getSelectedLang(){
            if (getCurrentLang()==="fa"){
                this.selectedFlag=0;
            }
            else if (getCurrentLang()==="en"){
                this.selectedFlag=1;
            }
            else if (getCurrentLang()==="ar"){
                this.selectedFlag=2;
            }
            else {
                storeCurrentLang('en');
                this.selectedFlag=1;
            }
        },
        hover(){
          if (this.headerItems.find(item=>item.expanded===true)){
              return true;
          }
          else {
              return false;
          }
        },
        changeLanguage(i) {
            this.selectedFlag = i;
            if (this.selectedFlag === 0) {
                this.$i18n.locale = 'fa';
            }
            if (this.selectedFlag === 1) {
                this.$i18n.locale = 'en'
            }
            if (this.selectedFlag === 2) {
                this.$i18n.locale = 'ar'
            }
            storeCurrentLang(this.$i18n.locale);
        },
        /*  search() {
              /!*if (this.searchText.length > 0) {
                  console.log('sssss',this.$route.name);
                  if (this.$route.name!='searchResults'){
                      this.$router.push({
                          name: 'searchResults', params: {
                              text: this.searchText
                          }
                      });
                  }
                  else{
                      this.$router.replace({
                          name: 'searchResults', params: {
                              text: this.searchText
                          }
                      }).catch(()=>{});
                      // this.$store.dispatch('productManager/changeSearchStatus');
                  }


              }*!/
          },*/
        handleScroll() {
            if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                this.scrolled = true;
                // move up!
            }

            if (this.lastPosition > window.scrollY) {
                this.scrolled = false;
                // move down
            }

            this.lastPosition = window.scrollY;
            // this.scrolled = window.scrollY > 250;
        }
    },
    computed:{
        
        ...mapState({
            isLoggedIn: state => state.authManagement.isLoggedIn,
            mainMenu:state => state.homeManagement.mainMenu,
            user: state => state.authManagement.user,
            searchProducts: state => state.productManagement.searchProducts,
          })
    },
    created() {
        this.getSelectedLang();
        window.addEventListener("scroll", this.handleScroll);
        this.$store.dispatch('homeManagement/getMainMenu').then(res=>{
            for(const item of res.data.links){
                this.menuStates[item.id]=false
            }
            this.menuKey++;
            console.log(this.menuStates,res)
        });
        this.$store.dispatch(`authManagement/${CHECK_USER}`);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
}